export const GoogleMapApiConfig = 'AIzaSyDt5Yv4bnPJFC_SHb5CTjN0oIcUO3ukuqY';